import { render, staticRenderFns } from "./CustomerPicker.vue?vue&type=template&id=40d4bb41"
import script from "./CustomerPicker.vue?vue&type=script&lang=js"
export * from "./CustomerPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports